<template>
  <v-layout wrap>
    <v-flex xs12 sm10 justify-center align-center order-xs2 order-sm1
            class="title text-xs-center text-sm-left">
      <v-btn
        v-if="!!_allowBB"
        color="accent"
        depressed
        small
        @click="$router.push({name: `catalog/newDocument`,params: {docName: 'rezervirovanie'}})"
      >
        Новое резервирование
      </v-btn>
      <v-btn
        v-if="!!_allowB"
        color="accent"
        depressed
        small
        @click="$router.push({name: `catalog/newDocument`,params: {docName: 'schet'}})"
      >
        Новый счет
      </v-btn>
    </v-flex>
    <v-flex xs12 sm2 class="text-sm-right text-xs-center" nowrap order-xs1 order-sm2 justify-end align-end>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          icon
          color="grey"
          dark
          @click="loadData"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <span>Обновить</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DocumentsToolbar',
  computed: {
    ...mapGetters('user', {
      _allowB: 'allowB',
      _allowBB: 'allowBB'
    })
  },
  methods: {
    loadData () {
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped>

</style>
